// SCSS entry file
import '../_scss/main.scss';

// Load all image files from a directory
//require.context( '../_img/', true, /.*/ );

import $ from 'jquery';

import 'magnific-popup';

import './components/root';
import './smoothscroll';
import './cookie-script-localstorage';


// WEBPACK FOOTER //
// ./assets/_js/main.js